import React from 'react';
import * as Styles from './CreditsView.styles';
import { IconButton, IconNotification, ProgressBar } from 'gatorcomponents';
import { isBRServer } from '@/utils/Validators/validation';
import GradientButton from '../../../GradientButton';
import { parseISO } from 'date-fns';

const CreditsView = ({
  isProPlan,
  setShowCreditAnalysis,
  handleShowModalGetPro,
  product,
  credits,
  creditsViewLocale,
}) => {
  const creditsHasEnded = credits.percent_used >= 100;
  const progressBarGradient = () => {
    if (creditsHasEnded) return 'problemLight';

    if (isProPlan) return 'gradientSecondary';

    return 'gradientPrimary';
  };

  const date = parseISO(credits.renewal_date);
  const creditRenewalDateLabel = date.toLocaleDateString(isBRServer ? 'pt-BR' : 'es-ES', {
    day: '2-digit',
    month: 'short',
  });

  return (
    <Styles.CreditsViewWrapper data-testid="credits-view-wrapper">
      <Styles.CloseButtonWrapper>
        <IconButton onClick={() => setShowCreditAnalysis(false)} testId="close-button" />
      </Styles.CloseButtonWrapper>

      <Styles.EmptyContainer>
        <Styles.CreditsTopText>{creditsViewLocale.yourPlan}</Styles.CreditsTopText>
        <Styles.CreditsStudioPlan isProPlan={isProPlan}>{product.title}</Styles.CreditsStudioPlan>
      </Styles.EmptyContainer>

      {!creditsHasEnded && <Styles.CreditsDescription>{creditsViewLocale.creditsUsedPercentage(credits.percent_used)}</Styles.CreditsDescription>}

      {creditsHasEnded && !isProPlan && <Styles.CreditsDescription>{creditsViewLocale.creditsHasEndedUpgrade}</Styles.CreditsDescription>}
      {creditsHasEnded && isProPlan && <Styles.CreditsDescription>{creditsViewLocale.creditsHasEnded}</Styles.CreditsDescription>}

      <Styles.EmptyContainer>
        <ProgressBar
          progress={credits.percent_used}
          size="md"
          color={progressBarGradient()}
          progressWithBorderRadius
        />

        <Styles.CreditsEstimativeContainer>
          <Styles.CreditsEstimative>{creditsViewLocale.creditsUsed(credits.used)}</Styles.CreditsEstimative>
          <Styles.CreditsEstimative>{creditsViewLocale.creditsAvailable(credits.available)}</Styles.CreditsEstimative>
        </Styles.CreditsEstimativeContainer>
      </Styles.EmptyContainer>

      <Styles.NextCreditsChargeAlert>
        <IconNotification size="sm" color="primaryBlue" />
        <Styles.NextCreditsCardText>{creditsViewLocale.nextRecharge(creditRenewalDateLabel)}</Styles.NextCreditsCardText>
      </Styles.NextCreditsChargeAlert>

      {!isProPlan && (
        <>
          <Styles.CreditsDescription>{creditsViewLocale.upgradePlan}</Styles.CreditsDescription>

          <Styles.ButtonContainer>
            <GradientButton
              testId="upgrade-to-pro-button"
              label={creditsViewLocale.goToProButtonLabel}
              onClick={() => handleShowModalGetPro && handleShowModalGetPro()}
              variant="primary"
              height="40px"
              width="full"
              size="md"
            />
          </Styles.ButtonContainer>
        </>
      )}

      <Styles.LearnMoreDescription>{creditsViewLocale.learnMore}</Styles.LearnMoreDescription>
    </Styles.CreditsViewWrapper>
  );
};

export default CreditsView;
